export default __webpack_public_path__ + "static/media/payment_system_sbp.a35c8137.png";